import React from 'react';
import PropTypes from 'prop-types';

import SearchInput from 'components/search_sidebar/sidebar_search';
import FilterButton from 'components/ui/filter_button';
import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';
import ResponsiveFilterContainer from 'components/search_page/responsive_filter_container';
import CurrentFilters from 'components/search_page/current_filters';
import Tag from 'components/tags/tag';

export default function OptionsFilters({
  createdByFilter,
  createdByOptions,
  documentTypeFilter,
  documentTypeOptions,
  searchText,
  onCreatedByChange,
  onDocumentTypeChange,
  onSearchChange,
  onSearchClear,
}) {
  const handleDocumentTypeChange = (e) => {
    const value = e.target.value;
    const currentFilters = documentTypeFilter || [];

    if (currentFilters.includes(value)) {
      onDocumentTypeChange(currentFilters.filter(v => v !== value));
    } else {
      onDocumentTypeChange([...currentFilters, value]);
    }
  };

  const handleCreatedByChange = (e) => {
    const value = e.target.value;
    const currentFilters = createdByFilter || [];

    if (currentFilters.includes(value)) {
      onCreatedByChange(currentFilters.filter(v => v !== value));
    } else {
      onCreatedByChange([...currentFilters, value]);
    }
  };

  const handleRemoveDocumentType = (value) => {
    onDocumentTypeChange((documentTypeFilter || []).filter(v => v !== value));
  };

  const handleRemoveCreatedBy = (value) => {
    onCreatedByChange((createdByFilter || []).filter(v => v !== value));
  };

  const handleClearFilters = () => {
    onDocumentTypeChange([]);
    onCreatedByChange([]);
  };

  const renderAppliedFilters = () => {
    const tags: React.ReactElement[] = [];

    (documentTypeFilter || []).forEach((value) => {
      const option = documentTypeOptions.find(o => o.value === value);
      if (option) {
        tags.push(
          <Tag
            key={`docType-${value}`}
            name={value}
            removable
            onRemove={() => handleRemoveDocumentType(value)}
          >
            Document Type: {option.label}
          </Tag>
        );
      }
    });

    (createdByFilter || []).forEach((value) => {
      const option = createdByOptions.find(o => o.value === value);
      if (option) {
        tags.push(
          <Tag
            key={`createdBy-${value}`}
            name={value}
            removable
            onRemove={() => handleRemoveCreatedBy(value)}
          >
            Created By: {option.label}
          </Tag>
        );
      }
    });

    if (tags.length === 0) return null;

    return (
      <div className="mt-3">
        <CurrentFilters raw onClearFilters={handleClearFilters}>
          {tags}
        </CurrentFilters>
      </div>
    );
  };

  return (
    <div className="mb-3">
      <ResponsiveFilterContainer>
        <SearchInput
          placeholder="Search Documents"
          value={searchText}
          onChange={onSearchChange}
          onClear={onSearchClear}
        />

        {documentTypeOptions.length > 0 && (
          <FilterButton
            filtersApplied={documentTypeFilter?.length > 0}
            label="Document Type"
            name="documentTypeFilter"
            popoverBodyClassName="p-3"
          >
            <FilterCheckboxGroup
              options={documentTypeOptions}
              selected={documentTypeFilter || []}
              onChange={handleDocumentTypeChange}
            />
          </FilterButton>
        )}

        {createdByOptions.length > 0 && (
          <FilterButton
            filtersApplied={createdByFilter?.length > 0}
            label="Created By"
            name="createdByFilter"
            popoverBodyClassName="p-3"
          >
            <FilterCheckboxGroup
              options={createdByOptions}
              selected={createdByFilter || []}
              onChange={handleCreatedByChange}
            />
          </FilterButton>
        )}
      </ResponsiveFilterContainer>

      {renderAppliedFilters()}
    </div>
  );
}

OptionsFilters.propTypes = {
  createdByFilter: PropTypes.arrayOf(PropTypes.string),
  createdByOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
  documentTypeFilter: PropTypes.arrayOf(PropTypes.string),
  documentTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })),
  searchText: PropTypes.string,
  onCreatedByChange: PropTypes.func.isRequired,
  onDocumentTypeChange: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onSearchClear: PropTypes.func,
};
